export const GET_LIST_POSTS = '/post/list';
export const GET_POST_INFO = '/post/getById';
export const CREATE_POST = '/post/create';
export const UPDATE_POST = '/post/update';
export const DELETE_POST = '/post/delete';
